module.exports = __webpack_public_path__ + "img/bg_center.18835e89.png";